export const formatCurrency = (amount: number, dp?: number): string => {
  const defaultDp = amount % 1 === 0 ? 0 : 2;
  const validDp = dp !== undefined && dp >= 0 && dp <= 20 ? dp : defaultDp;

  const formatter = new Intl.NumberFormat("en-NZ", {
    style: "currency",
    currency: "NZD",
    minimumFractionDigits: validDp,
    maximumFractionDigits: 2,
    currencyDisplay: "narrowSymbol"
  });

  return formatter.format(amount);
};
